import React from "react";
import {Badge, Card, Table} from "react-bootstrap";
import { FaBell, FaTrash } from "react-icons/fa";
import "animate.css";

const statusBadges = {
    READING: { bg: "success", text: "dark", label: "R", description: "You are currently reading this book and preparing to write an honest and fair review. The deadlines are within the agreed time frame, and nothing is overdue.", category: "Assignment", opacity: "bg-opacity-50" },
    READING_RIDT: { bg: "warning", text: "black", label: "R", description: "Today is the last day to submit your review. While the deadline hasn’t been missed yet, it's a good idea to speed up and complete your review before the day ends.", category: "Assignment", opacity: "" },
    READING_RE: {
        bg: "danger",
        text: "white",
        label: <FaBell className="animate__animated animate__bounceIn animate__infinite" />,
        description: "The deadline for this assignment has passed. The good news is that you have an extra 24 hours to complete and submit your review. If not submitted within this grace period, the assignment will be automatically canceled, and any advance Virt payments or bonuses will be deducted from your balance.",
        category: "Assignment",
        opacity: ""
    },
    REPORTED: { bg: "success", text: "dark", label: "A", description: "You have reported that you published your review on Amazon or Audible. Now, we are waiting for Amazon to approve and make your review live, which usually takes a few days (maximum of 5-7 days). If your review is published sooner, you can confirm it by submitting the link on the assignment page.", category: "Assignment", opacity: "bg-opacity-50" },
    REPORTED_RFU: { bg: "warning", text: "dark", label: "A", description: "It has been 5 days since you reported your review was submitted to Amazon or Audible. Now would be a good time to check if your review is live. If it is, paste the link into our automated review confirmation system. If it’s not yet published, don’t worry—we will wait a little longer.", category: "Assignment", opacity: "" },
    REPORTED_RV: {
        bg: "danger",
        text: "white",
        label: <FaTrash className="animate__animated animate__wobble animate__infinite" />,
        description: "More than 12 days have passed since you reported your review as submitted. This is an unusually long time for a review to go live on Amazon or Audible. We, along with the assignment author, are getting concerned. Please check if you really submitted the review and make sure there are no issues with your reviewer account.",
        category: "Assignment",
        opacity: ""
    },
    SUCCESS: { bg: "success", text: "white", label: "S", description: "Your review has been confirmed! Mission accomplished. Thank you for your effort and hard work—we truly appreciate it!", category: "Assignment", opacity: "" },
    LIVE: { bg: "success", text: "white", label: "L", description: "Your book has been approved by a moderator and is now live. You can now create assignments for this book to get reviews.", category: "Book", opacity: "" },
    NEW: { bg: "info", text: "dark", label: "M", description: "Your book is under moderation. We are reviewing the accuracy of the information you provided. Please wait a little longer—your book will be live soon.", category: "Book", opacity: "" },
    NEEDFIX: { bg: "warning", text: "dark", label: "N", description: "We found some inaccuracies in your book details. Please review the feedback from our team, make the necessary corrections, and resubmit your book for moderation.", category: "Book", opacity: "" },
};

const BadgeTable = () => {
    return (
        <Card className="p-3 w-100 mt-2">
            <div className="container mb-2 mt-2">
        <div className="text-muted ">
        <h5>Badge Meaning & How to Understand It:</h5>
            <div style={{ overflowX: 'auto', whiteSpace: 'collapse', paddingBottom: '8px' }}>
                <Table
                    striped
                    bordered
                    hover
                    size="sm"
                    className="shadow-sm rounded small mb-0"
                    style={{ minWidth: '890px' }} // минимальная ширина для корректного скролла
                >
            <thead className="bg-success small bg-opacity-50 text-white">
            <tr>
                <th className="text-muted" >Badge:</th>
                <th className="text-muted text-center" >Category:</th>
                <th className="text-muted" >Explanation of Badge Meaning:</th>
            </tr>
            </thead>
            <tbody>

            {Object.entries(statusBadges).map(([key, { bg, text, label, description, category, opacity }]) => (
                <tr key={key} className="small" style={{ height: "20px" }}>
                    <td className="text-center align-text-center p-2">
                        <Badge bg={bg} className={`text-${text} ${opacity}`}>{label}</Badge>
                    </td>
                    <td className="p-2 text-center">{category}</td>
                    <td className=" p-2">{description}</td>
                </tr>
            ))}
            </tbody>
        </Table>
        </div>
        <div className="text-muted small">
            <p className="mb-2">
                <strong>Note:</strong> The badges are color-coded to help you quickly identify the status of your assignments and books. The colors represent different statuses, making it easier to manage your tasks.
            </p>
            <p className="mb-2">
                <strong>Assignment Badges:</strong> These badges indicate the status of your assignments, including reading, reporting, and success statuses.
            </p>
            <p className="mb-2">
                <strong>Book Badges:</strong> These badges indicate the status of your books, including live, new, and need fix statuses.
            </p>

        </div>
        </div>
        </div>
        </Card>
    );
};

export default BadgeTable;
